export const onboardingScreensRoutes = {
  list: "",
  new: "new",
  edit: ":id/edit",
} as const;
